
import React, { Component } from "react";
import API from "../utils/API";
import { Link } from "react-router-dom";
import { Col, Row, Container } from "../components/Grid";
import { FinalList, FinalListItem, } from "../components/FinalList";
import Footer from "../components/Footer";

class Admin extends Component {
  state = {
    shinbay: [],
    title: "",
    description: "",
    active_menu: "MAIN MENU",
    all_menus: [
      { name: 'MAIN MENU' },
      { name: 'SAKE' },
      // { name: 'WHITE WINE' },
      { name: 'WINE' },
      { name: 'BEER' },
      // { name: 'COCKTAIL' },
    ]
//     synopsis: ""
  };

  componentDidMount() {
    this.loadAdmin();
  }

  loadAdmin = () => {
    API.getAdmin()
      .then(res =>
        this.setState({ shinbay: res.data, title: "", description: "" })
      )
      .catch(err => console.log(err));
  };

  deleteShindata = id => {
    API.deleteShindata(id)
      .then(res => this.loadAdmin())
      .catch(err => console.log(err));
  };

  handleInputChange = event => {
    const { name, value } = event.target;
    this.setState({
      [name]: value
    });
  };

  handleFormSubmit = event => {
    event.preventDefault();
    if (this.state.title && this.state.description) {
      API.saveShindata({
        title: this.state.title,
        description: this.state.description,
//         synopsis: this.state.synopsis
      })
        .then(res => this.loadAdmin())
        .catch(err => console.log(err));
    }
  };

  handleMenuClick = event => {
    let current_menu = "MAIN MENU";
    if('undefined' !== event.target.getAttribute('data-name')) {
      this.setState({active_menu: event.target.getAttribute('data-name')});
    }
  };

  render() {
    return (
      <Container fluid>
        <Row>
   
        <Col size="md-12">
      
            {this.state.shinbay.length ? (
              <FinalList menus={this.state.all_menus} menuClicked={(event) => this.handleMenuClick(event)}>
                {this.state.shinbay.map(shindata => (
                  ( shindata.category === this.state.active_menu ) ?
                    ( shindata.display_on === 'On' ) ?
                    <FinalListItem key={shindata._id}>
                  
                        <strong>
                          {shindata.title} 
                        </strong>
                        <p>
                        {shindata.description}
                        </p>
                     
                    </FinalListItem>
                    : null
                  : null
                ))}
                   <Footer>
            </Footer>  
              </FinalList>
              
            ) : (
            <p>No Results to Display</p>

            )}

          </Col>
      
        </Row>
    
      </Container>
      
    );
  }
}

export default Admin;


{/* <Link to="/">← Back to descriptions</Link> */}